import { FilespaceStatus } from '@lucidlink/dto/validation';
import { translate } from '@lucidlink/uicore';
export const getStatusAnnouncement = ({ isMigrating, name, status, }) => {
    if (isMigrating) {
        return translate('{{name}}: upgrading', { name });
    }
    switch (status) {
        case FilespaceStatus.SETUP_IN_PROGRESS:
            return translate('{{name}}: setting up', { name });
        case FilespaceStatus.SUSPEND_IN_PROGRESS:
        case FilespaceStatus.UNSUSPEND_IN_PROGRESS:
            return translate('{{name}}: in progress', { name });
        case FilespaceStatus.ERRORED:
        case FilespaceStatus.SETUP_ERROR:
        case FilespaceStatus.SUSPEND_ERROR:
        case FilespaceStatus.UNSUSPEND_ERROR:
            return translate('{{name}}: error', { name });
        case FilespaceStatus.SUSPENDED:
            return translate('{{name}}: suspended', { name });
        case FilespaceStatus.READY:
        default:
            return translate('{{name}}: ready', { name });
    }
};
